import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.min.css";
import { createVuetify } from "vuetify";

const light = {
  background: "#F8F4F4",
  surface: "#FFFFFF",
  primary: "#3A86FF",
  secondary: "#2C2A3D",
  accent: "#FFDD57",
  success: "#2ECC71",
  "on-success": "#FFFFFF",
  warning: "#FFDD57",
  error: "#FF4D4F",
};

const dark = {
  primary: "#3A86FF",
  secondary: "#2C2A3D",
  accent: "#FFDD57",
  success: "#2ECC71",
  "on-success": "#FFFFFF",
  warning: "#FFDD57",
  error: "#FF4D4F",
};

export default createVuetify({
  theme: {
    defaultTheme: "light",
    themes: {
      light: { dark: false, colors: light },
      dark: { dark: true, colors: dark },
    },
  },
  defaults: {
    VSwitch: { color: "primary" },
    VCheckbox: { color: "primary" },
    VRadio: { color: "primary" },
  },
});
